var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1804 4.73318C20.6954 4.73318 18.4713 5.94135 17.0846 7.79479C15.698 5.94135 13.4739 4.73318 10.9889 4.73318C6.77403 4.73318 3.35547 8.16548 3.35547 12.4078C3.35547 14.0416 3.61632 15.5518 4.06939 16.9521C6.23859 23.8167 12.9247 27.9217 16.2334 29.0475C16.7002 29.2123 17.4691 29.2123 17.9358 29.0475C21.2446 27.9217 27.9307 23.8167 30.0999 16.9521C30.5529 15.5518 30.8138 14.0416 30.8138 12.4078C30.8138 8.16548 27.3952 4.73318 23.1804 4.73318Z",
    fill: "#D73427"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.6c801e39e1cf70029954b5af9617e9de.svg";
export { ForwardRef as ReactComponent };